class Translation {
  constructor($translate) {
    this.$translate = $translate;
  }
  translateWith(key, params, lang) {
    const translated = this.$translate.instant(key, params, undefined, lang);
    return translated;
  }
  translateWithMultiLang(key, params, languages) {
    const localizedObject = {};
    localizedObject.en = this.translateWith(key, params);
    languages.forEach((element) => {
      const translatedValue = this.translateWith(key, params, element);
      // Check if the translation key  doesn't exists
      if (translatedValue === key) {
        localizedObject[element] = localizedObject.en;
      } else {
        localizedObject[element] = translatedValue;
      }
    });
    return localizedObject;
  }
}

export default Translation;



// WEBPACK FOOTER //
// ./src/services/translation/translation.service.js